module.exports = __webpack_public_path__ + "img/correct.9002beb1.svg";